import { Button } from "antd";
import IntlMessages from "@iso/components/utility/intlMessages";
import React from "react";
import { createNotification } from "../Notification";
import { useIntl } from "react-intl";
import { sendResetPasswordCode } from "@/services/auth/api";

function PasswordForm({ data }) {
  const intl = useIntl();

  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    await sendResetPasswordCode(data.email)
      .then(() => {
        createNotification(
          "success",
          intl.formatMessage({ id: "page.my-account.password.success.title" }),
          intl.formatMessage({
            id: "page.my-account.password.success.description",
          }),
        );
      })
      .catch((error) => {
        console.error(error);
        if (error.response.data) {
          createNotification("error", "Fail", error.response.data.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Button
      className="bg-primary border-0 text-white !px-12 shadow-none"
      size="large"
      htmlType="submit"
      onClick={handleSubmit}
      loading={loading}
      shape="round"
      type="primary"
    >
      <IntlMessages id="page.forgotPasswordCTA" />
    </Button>
  );
}

export default PasswordForm;
